<template>
  <div class="choice-boxes">
    <div
      v-for="(choice, i) in data.options"
      :key="i"
      :class="[i === activeItem ? 'choice-boxes__box--active' : '']"
      class="justify-content-center align-items-center choice-boxes__box"
      @click="selectItem(i)"
    >
      <span class="choice-boxes__box__text"> {{ choice.choice }} </span>
    </div>
  </div>
</template>

<script>
import Utag from '@/mixins/Utag'
export default {
  name: 'ChoiceBox',
  mixins: [Utag],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      activeItem: null
    }
  },
  mounted () {
    if (this.$attrs.value && this.$attrs.value.result) {
      this.setActiveBasedOnSelected()
    }
  },
  methods: {
    selectItem (i) {
      this.activeItem = i
      this.$emit('input', { result: this.data.options[i].value })
      this.updateTracking(i)
    },
    setActiveBasedOnSelected () {
      const dataOptions = [...this.data.options]
      // allow active item to display on back btn
      const activeIndex = dataOptions.findIndex(item => item.value === this.$attrs.value.result)
      this.activeItem = activeIndex
    },
    updateTracking (i) {
      if (this.data.options[i].tracking) {
        this.generalTracking(this.data.options[i].tracking)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.choice-boxes {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: $screen-md) {
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    flex-wrap: wrap;
    justify-content: center;
    max-width: unset;
    width: unset;
  }

  &__box {
    cursor: pointer;
    color: $black;
    margin-bottom: 8px;
    position: relative;
    border-radius: 6px;
    height: 52px;
    width: 288px;
    background-color: $white;
    padding: 12px 16px;
    display: flex;
    border: 1px solid #deddde;

    @media (min-width: 421px) {
      width: 340px;
    }

    @media (min-width: $screen-md) {
      margin-bottom: 14px;
      height: 56px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    &__text {
      flex-grow: 1;
      font-size: 14px;
      line-height: 19.2px;

      @media (min-width: $screen-md) {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 19.2px;
      }
    }

    &--active, &:hover {
      border: $choice-box-checkbox-border-selected;
    }

    &:hover {
      position: relative;
      top: -2px;
    }
  }
}
</style>
